// Map backend field names (snake_case) to form field names (camelCase)
const mapFieldName = (field) => {
  const mapping = {
    'old_password': 'oldPassword',
    'new_password': 'newPassword',
    'confirm_password': 'confirmPassword'
  }
  return mapping[field] || field
}

// Translate backend error messages to Spanish
const translateErrorMessage = (message) => {
  const translations = {
    'Your password is not valid.': 'Tu contraseña actual es incorrecta.',
    'Cannot reuse one of your last 3 passwords.': 'No puedes reutilizar una de tus últimas 3 contraseñas.',
    'Password must contain at least 1 digit, 1 lowercase, 1 uppercase, 1 special character, and be 8-20 characters.': 'La contraseña debe contener al menos 1 dígito, 1 minúscula, 1 mayúscula, 1 carácter especial, y tener entre 8-20 caracteres.',
    'Password should not contain mailbox, mailbox_domain, first_name, second_name, last_name, second_last_name.': 'La contraseña no debe contener tu nombre, apellido o correo electrónico.'
  }
  return translations[message] || message
}

// Transform backend errors to redux-form format
export const transformBackendErrors = (error) => {
  if (!error || typeof error !== 'object') return {}
  const formErrors = {}
  Object.keys(error).forEach(field => {
    const mappedField = mapFieldName(field)
    const messages = error[field]
    const rawMessage = Array.isArray(messages) ? messages[0] : messages
    formErrors[mappedField] = translateErrorMessage(rawMessage)
  })
  return formErrors
}
